import FooterFlags from './FooterFlags';

export default FooterFlags;
